<div class="form-field">
    @if(label) {
      <label class="form-field__label">
        {{ label }}
        @if(required) {
          <span class="form-field__required">*</span>
        }
      </label>
    }
  
    <textarea
      [id]="formControlName"
      [placeholder]="placeholder"
      [required]="required"
      [disabled]="control?.disabled"
      (input)="onInput($event)"
      (blur)="onTouched()"
      [value]="value"
      class="form-field__textarea"
      [ngClass]="{
        'form-field__textarea--invalid': isInvalid,
        'form-field__textarea--disabled': control?.disabled
      }"
      [cols]="cols"
      [rows]="rows"
    ></textarea>
  
    @if (errorMessage) {
      <div class="form-field__error">
        {{ errorMessage }}
      </div>
    }
  </div>
  